import BaseModule from '@core/modules/base-module/base-module';
//
const textImageBlock = new BaseModule();
textImageBlock.name = 'text-image-block';
textImageBlock.init();
